/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TeamSummary
 */
export interface TeamSummary {
  /**
   *
   * @type {string}
   * @memberof TeamSummary
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof TeamSummary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TeamSummary
   */
  description?: string | null;
  /**
   *
   * @type {number}
   * @memberof TeamSummary
   */
  memberCount: number;
}

/**
 * Check if a given object implements the TeamSummary interface.
 */
export function instanceOfTeamSummary(value: object): value is TeamSummary {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("memberCount" in value) || value["memberCount"] === undefined)
    return false;
  return true;
}

export function TeamSummaryFromJSON(json: any): TeamSummary {
  return TeamSummaryFromJSONTyped(json, false);
}

export function TeamSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamSummary {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    memberCount: json["memberCount"],
  };
}

export function TeamSummaryToJSON(json: any): TeamSummary {
  return TeamSummaryToJSONTyped(json, false);
}

export function TeamSummaryToJSONTyped(
  value?: TeamSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    name: value["name"],
    description: value["description"],
    memberCount: value["memberCount"],
  };
}
